<template>
    <v-container
        :id="section._key"
        :class="{
            'text-center': true,
            'multitabs--md-and-down': $vuetify.breakpoint.mdAndDown
        }"
    >
        <v-row column justify-center align-center>
            <v-col cols="12">
                <!-- <pre style="text-align:left">{{ section }}</pre> -->
                <v-carousel
                height="auto"
                hide-delimiter-background
                show-arrows-on-hover
                v-if="$vuetify.breakpoint.xs">
                    <v-carousel-item
                    v-for="contentTab in section.contentTab"
                    :key="`item-${contentTab._key}`"
                    class="multitabs-item"
                    >
                        <ContentMultiTabsSub :contentTab = contentTab />
                    </v-carousel-item>

                </v-carousel>
                <v-tabs vertical v-else>
                    <v-tab
                        v-for="contentTab in section.contentTab"
                        :key="`tab-${contentTab._key}`"
                        left
                        class="multitabs-tab"
                    >
                        {{
                            contentTab.heading &&
                            contentTab.heading[$i18n.locale]
                                ? contentTab.heading[$i18n.locale]
                                : 'Missing Data'
                        }}
                    </v-tab>
                    <v-tab-item
                        v-for="contentTab in section.contentTab"
                        :key="`item-${contentTab._key}`"
                        class="multitabs-item"
                    >
                        <ContentMultiTabsSub :contentTab = contentTab />
                    </v-tab-item>
                </v-tabs>
                
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ContentMultiTabsSub from '~/components/ContentMultiTabsSub'
export default {
    name: 'ContentMultiTabs',
    components:{
        ContentMultiTabsSub
    },
    props: {
        section: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
        }
    },
    
}
</script>
